export const iterateObjectPropValues = (obj, callback) => {
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    callback(value);
  });
}